// extracted by mini-css-extract-plugin
module.exports = {"mobileBottomNav":"styles_mobileBottomNav__0bk73","mobileBottomNavItem":"styles_mobileBottomNavItem__e02XK"};